import { Button } from "reactstrap";

export const QuantityInput = ({
  value,
  maxQty = 10000,
  onChange,
  disabled,
}: {
  value: number;
  maxQty?: number;
  onChange?: (value: number) => void;
  disabled?: boolean;
}) => {
  const decrease = () => {
    const newQty = Math.max(value - 1, 1);
    onChange?.(newQty);
  };

  const increase = () => {
    const newQty = Math.min(value + 1, maxQty);
    onChange?.(newQty);
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center gap-1"
      style={{ minWidth: "80px" }} // constrain total width
    >
      {!disabled && (
        <Button color="secondary" outline size="sm" onClick={decrease}>
          -
        </Button>
      )}
      <input
        type="number"
        step="1"
        value={value}
        disabled={disabled}
        onChange={(e) => {
          let val = Number(e.target.value);
          if (isNaN(val) || val === 0) {
            val = 1;
          } else {
            val = Math.floor(Math.abs(val)); // Round down to nearest integer
          }
          if (val < 1) val = 1;
          if (val > maxQty) val = maxQty;
          onChange?.(val);
        }}
        onBlur={(e) => {
          let val = Number(e.target.value);
          if (isNaN(val) || val === 0) {
            val = 1;
          } else {
            val = Math.floor(Math.abs(val)); // Round down to nearest integer
          }
          if (val < 1) val = 1;
          if (val > maxQty) val = maxQty;
          onChange?.(val);
        }}
        className="form-control form-control-sm text-center"
        style={disabled ? { width: "70px" } : { width: "50px" }} // keep input small
        min={1}
        max={maxQty}
      />
      {!disabled && (
        <Button
          color="secondary"
          className="btn"
          outline
          size="sm"
          onClick={increase}
        >
          +
        </Button>
      )}
    </div>
  );
};
